export const SET_AUDIO_OTHERS_VOLUME = 'SET_OTHERS_VOLUME';
export const SET_AUDIO_HIGH_FREQUENCIES = 'SET_HIGH_FREQUENCIES';
export const SET_AUDIO_AMPLIFY = 'SET_AMPLIFY';
export const SET_AUDIO_BALANCE = 'SET_BALANCE';
